import React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Instance } from 'mobx-state-tree';
import { Anchor } from '../../store/models';
import { RouteComponentProps } from 'react-router';
import { AnchorStore, PharmacyStore, GroupStore, AuthenticationStore, SecretariatStore, ApplicationStore } from '../../store';
import { AnchorForm } from './AnchorForm';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Container } from '../common/styledComponents/StyledComponents';
import { Card } from '@blueprintjs/core';
import { Page, TLCode } from '../../common/enums';
import { inject, observer } from 'mobx-react';

interface AnchorPageProps extends WithTranslateProps, RouteComponentProps<{ id: string }> {
  AnchorStore?: Instance<typeof AnchorStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  GroupStore?: Instance<typeof GroupStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
    ApplicationStore?: Instance<typeof ApplicationStore>;
}

interface AnchorPageState {
  anchor: Instance<typeof Anchor> | undefined;
  isLoading: boolean;
}

@inject('AnchorStore', 'PharmacyStore', 'GroupStore', 'AuthenticationStore', 'SecretariatStore', 'ApplicationStore')
@observer
class AnchorPage extends React.Component<AnchorPageProps, AnchorPageState> {
  constructor(props: AnchorPageProps) {
    super(props);
    this.state = {
      anchor: undefined,
      isLoading: false,
    };
  }

  _isMounted = false;

  async fetchData() {
    const { GroupStore, AnchorStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    GroupStore!.checkListLoaded();
    const anchorId = parseInt(this.props.match.params.id, 10);
    if (anchorId > 0) {
      await AnchorStore!.checkListLoaded();
      const anchor = AnchorStore!.dataList.find((a) => a.anchorId === anchorId);
      this._isMounted && this.setState({ anchor });
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetchData();
  }

  backToSecretariatList = () => {
    const params = new URLSearchParams(this.props.location.search);
    const fromPage = params.get('from');

    if (fromPage === 'groupAnchorsTab') {
      const groupId = params.get('group');
      this.props.ApplicationStore!.navigate(`${Page.GroupPage}/${groupId}?from=anchors`);
      return;
    }

    var secretariatId = this.props.GroupStore!.dataList.find(
      (g) => g.groupId === this.state.anchor!.groupId,
    )!.secretariatId;
    this.props.ApplicationStore!.navigate(
      `${Page.SecretariatPage}/${secretariatId}?from=anchors`,
    );
  }

  getSecretariatId = () => {
    if (this.props.AuthenticationStore!.isSuperAdmin)
      return this.props.SecretariatStore!.selectedSecretariatId === 0
        ? undefined
        : this.props.SecretariatStore!.selectedSecretariatId;
    if (this.props.AuthenticationStore!.isSecretariat) return this.props.AuthenticationStore!.secretariatId!;
    return undefined;
  };

  renderTitle = () => {
    const anchor = this.state.anchor;
    return anchor !== undefined ? (
      <h1>
        {anchor!.name + ' (' + this.props.GroupStore!.dataList.find((g) => g.groupId === anchor.groupId)!.name + ')'}
      </h1>
    ) : (
      <h1>{this.props.translate(TLCode.AddAnchor)}</h1>
    );
  };

  render() {
    const { GroupStore, PharmacyStore, AnchorStore, translate } = this.props;
    const { anchor, isLoading } = this.state;
    return (
      <MainSectionLayout isLoading={isLoading} renderHeader={this.renderTitle}>
        <Container>
          <Card style={{ height: '100%' }}>
            <AnchorForm
              anchor={anchor}
              save={AnchorStore!.saveAnchor}
              groups={GroupStore!.dataList.filter(
                (g) => this.getSecretariatId() === undefined || this.getSecretariatId() === g.secretariatId,
              )}
              pharmacies={PharmacyStore!.dataList.filter(
                (p) => this.getSecretariatId() === undefined || this.getSecretariatId() === p.secretariatId,
              )}
              linkPharmacyToAnchor={PharmacyStore!.linkToAnchor}
              unlinkPharmacyFromAnchor={PharmacyStore!.unlinkAnchor}
              translate={translate}
            />
            <button
              className="bp3-button bp3-intent-primary bp3-icon-arrow-left"
              onClick={this.backToSecretariatList}
              style={{ marginTop: '10px' }}
            >
              {translate(TLCode.BackToList)}
            </button>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(AnchorPage);
